module.exports = __webpack_public_path__ + "img/logo-sesi-dark.960ed376.svg";